<template>
  <base-review-member-popup :title="title" @close="$emit('close')">
    <assign-review-members-list
      :review-members="reviewMembers"
      :selected-ids="selectedIds"
      @assign="$emit('assign', $event)"
      @unassign="$emit('unassign', $event)"
    />
  </base-review-member-popup>
</template>

<script>
import BaseReviewMemberPopup from './BaseReviewMemberPopup';
import AssignReviewMembersList from './AssignReviewMembersList';
import { ReviewMember } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'AssignReviewMembersPopup',
  components: { BaseReviewMemberPopup, AssignReviewMembersList },
  props: {
    title: {
      type: String,
      default: 'Reviewers',
    },
    reviewMembers: {
      type: Array,
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMember),
      required: true,
    },
    assignedReviewMembers: {
      type: Array,
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMember),
      default: () => [],
    },
  },
  emits: ['assign', 'unassign', 'close'],
  computed: {
    selectedIds() {
      return this.assignedReviewMembers.map((member) => member.id);
    },
  },
};
</script>
